module.exports = window["React"];